import { useContext, useEffect, useState } from 'react'
import { CircularProgress, Fab, FormControl, IconButton, InputLabel, MenuItem, Paper, Select, Tooltip } from '@mui/material'
import { useQuery, useQueryClient } from 'react-query'
import { getProperties } from '../../services/api/Property'
import { getTowersBuildingsByProperty } from '../../services/api/TowerBuilding'
import { getFloorsByTowerBuilding } from '../../services/api/Floor'
import TypeOne from '../../components/Card/TypeOne'
import styles from './styles.module.css'
import { AuthContext } from '../../context/AuthContext'
import { SnackbarGlobal } from '../../components/Snackbar'
import Add from './complementary/Add'
import Edit from './complementary/Edit'
import Spaces from './Spaces'
import Images from './Images'
import InteractiveMap from './InteractiveMap'
import { Edit as EditIcon, Add as AddIcon, Layers as LayersIcon, PictureInPicture as PictureInPictureIcon, BurstMode as BurstModeIcon  } from '@mui/icons-material'

export default function Floor() {
  const { setTitlePage } = useContext(AuthContext)
  const [openAdd, setOpenAdd] = useState(false)
  const [openEdit, setOpenEdit] = useState(false)
  const [openSpaces, setOpenSpaces] = useState(false)
  const [openImages, setOpenImages] = useState(false)
  const [openInteractiveMap, setOpenInteractiveMap] = useState(false)
  const [propertySelected, setPropertySelected] = useState(null)
  const [propertyId, setPropertyId] = useState(null)
  const [towerBuildingSelected, setTowerBuildingSelected] = useState(null)
  const [towerBuildingId, setTowerBuildingId] = useState(null)
  const [floorSelected, setFloorSelected] = useState({})
  const [messageSnackbar, setMessageSnackbar] = useState('');
  const [authError, setAuthError] = useState(false);
  const queryClient = useQueryClient()
  const { isLoading: plIsLoading, isFetching: plIsFetching, error: plError, data: properties } = useQuery(
    'propertiesList',
    getProperties,
    { refetchOnWindowFocus: false }
  )
  const { isLoading: tbLoading, isFetching: tbFetching, error: tbError, data: towersBuildings } = useQuery(
    ['towersBuildingsList', propertyId], 
    () => getTowersBuildingsByProperty(propertyId), 
    { refetchOnWindowFocus: false,  enabled: (propertyId !== null && propertyId !== undefined && propertyId !== "") }
  )
  const { isLoading: fLoading, isFetching: fFetching, error: fError, data: floors } = useQuery(
    ['floorsList', towerBuildingId], 
    () => getFloorsByTowerBuilding(towerBuildingId), 
    { refetchOnWindowFocus: false,  enabled: (towerBuildingId !== null && towerBuildingId !== undefined && towerBuildingId !== "") }
  )

  useEffect(() => { setTitlePage("Pisos") }, [])

  const handleRefresData = () => { queryClient.invalidateQueries('floorsList') }

  const handleResetActions = (action) => {
    if(action === "add") setOpenAdd(false)
    if(action === "edit") setOpenEdit(false)
    if(action === "spaces") setOpenEdit(false)
    if(action === "interactive_map") setOpenInteractiveMap(false)
    if(action === "images") setOpenImages(false)
  }

  const handleWatchAction = (action, cancel, error, success) => {
    if(cancel) return;
    if(error.message) {
      setMessageSnackbar(error.message);
      setAuthError(true);
      return;
    }
    if(success) {
      alert("Acción realizada correctamente")
      handleRefresData()
      handleResetActions(action)
      return;
    }
  }

  if(plIsLoading || plIsFetching) return <div>Cargando...</div>

  if(plError) return <div> Ha ocurrido un error </div>

  const Actions = ({ floor }) => (<>
    <Tooltip title="Editar propiedad">
      <IconButton onClick={() => { setOpenEdit(true); setFloorSelected(floor) }}> <EditIcon color="info"/> </IconButton>
    </Tooltip>
    <IconButton onClick={() => { setOpenImages(true); setFloorSelected(floor) }}> <BurstModeIcon color="secondary"/> </IconButton>
    <Tooltip title="Mapa interactivo">
      <IconButton onClick={() => { setOpenInteractiveMap(true); setFloorSelected(floor) }}> <LayersIcon color="success"/> </IconButton>
    </Tooltip>
    <Tooltip title="Editar espacios">
      <IconButton onClick={() => { setOpenSpaces(true); setFloorSelected(floor) }}> <PictureInPictureIcon color="success"/> </IconButton>
    </Tooltip>
  </>)

  return (<>
    <div className={styles.container_property_selector}>
      <Paper style={{padding: 20, borderRadius: 16}}>
        <FormControl fullWidth margin="normal">
          <InputLabel id="select-property-label">Propiedades</InputLabel>
          <Select labelId="select-property-label" value={propertyId} label="Propiedad" required inputProps={{ name: 'property', id: 'select-property' }}>
            <MenuItem value="" onClick={() => setPropertyId("")}>Seleccionar</MenuItem>
            { properties.data.map((property, index) => (
              <MenuItem key={index} value={property._id} onClick={() => { setPropertyId(property._id); setPropertySelected(property); }}>{property.property_name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        { (tbLoading || tbFetching) ? <div><CircularProgress /></div> :
        (towersBuildings !== undefined) && <>
        <FormControl fullWidth margin="normal">
          <InputLabel id="select-property-label">Torres Edificios</InputLabel>
          <Select labelId="select-property-label" value={towerBuildingId} label="Torres Edificios" required inputProps={{ name: 'towerBuilding', id: 'select-towerBuilding' }}>
            <MenuItem value="" onClick={() => setTowerBuildingId("")}>Seleccionar</MenuItem>
            { towersBuildings.data.map((tb, index) => (
              <MenuItem key={index} value={tb._id} onClick={() => { setTowerBuildingId(tb._id); setTowerBuildingSelected(tb); }}>{tb.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        </>}
      </Paper>
    </div>
    { (fLoading || fFetching) ? <div className={styles.container_cards}><CircularProgress /></div> :
    (floors !== undefined) &&
    <div className={styles.container_cards}>
      { floors.data.map((floor, index) => 
        <TypeOne actions={<Actions floor={floor}/>} key={index} name={floor.name} logo={propertySelected.logo} image={propertySelected.property_photo} />
      )}
    </div>
    }
    <span className={styles.fab_add}>
      <Tooltip title="Agregar"><Fab color="primary" onClick={() => setOpenAdd(true)}><AddIcon /></Fab></Tooltip>
    </span>
    <Add open={openAdd} setOpen={setOpenAdd} towerBuildingId={towerBuildingId} reportAction={handleWatchAction}/>
    <Edit open={openEdit} setOpen={setOpenEdit} floor={floorSelected} reportAction={handleWatchAction}/>
    <Spaces open={openSpaces} setOpen={setOpenSpaces} floor={floorSelected} reportAction={handleWatchAction}/>
    <InteractiveMap open={openInteractiveMap} setOpen={setOpenInteractiveMap} floor={floorSelected} reportAction={handleWatchAction}/>
    <Images open={openImages} setOpen={setOpenImages} floor={floorSelected} reportAction={handleWatchAction}/>
    <SnackbarGlobal vertical='bottom' horizontal='center' open={authError} close={() => setAuthError(false)} message={messageSnackbar} />
  </>)
}